import { apiClient } from './client';
import { downloadPdfBlob } from '../utils/downloadPdf';
import {
  NonconformanceReport,
  NonconformanceReportPayload,
} from '../types/nonconformanceReport';
import { SequentialCodeSuggestion } from '../types/sequentialCode';

export async function fetchNonconformanceReports(
  keyword?: string,
  contractId?: number | null
): Promise<NonconformanceReport[]> {
  const params: Record<string, string | number> = {};
  if (keyword?.trim()) params.q = keyword.trim();
  if (contractId != null) params.contractId = contractId;
  const { data } = await apiClient.get<NonconformanceReport[]>('/nonconformance-reports', {
    params: Object.keys(params).length ? params : undefined,
  });
  return data;
}

export async function fetchNonconformanceReport(reportId: number): Promise<NonconformanceReport> {
  const { data } = await apiClient.get<NonconformanceReport>(`/nonconformance-reports/${reportId}`);
  return data;
}

export async function fetchNextNcrReportNo(): Promise<SequentialCodeSuggestion> {
  const { data } = await apiClient.get<SequentialCodeSuggestion>(
    '/nonconformance-reports/suggestions/report-no'
  );
  return data;
}

export async function createNonconformanceReport(
  payload: NonconformanceReportPayload
): Promise<NonconformanceReport> {
  const { data } = await apiClient.post<NonconformanceReport>('/nonconformance-reports', payload);
  return data;
}

export async function updateNonconformanceReport(
  reportId: number,
  payload: NonconformanceReportPayload
): Promise<NonconformanceReport> {
  const { data } = await apiClient.patch<NonconformanceReport>(
    `/nonconformance-reports/${reportId}`,
    payload
  );
  return data;
}

export async function closeNonconformanceReport(reportId: number): Promise<NonconformanceReport> {
  const { data } = await apiClient.post<NonconformanceReport>(
    `/nonconformance-reports/${reportId}/close`
  );
  return data;
}

export async function reopenNonconformanceReport(reportId: number): Promise<NonconformanceReport> {
  const { data } = await apiClient.post<NonconformanceReport>(
    `/nonconformance-reports/${reportId}/reopen`
  );
  return data;
}

export async function approveNonconformanceReport(
  reportId: number
): Promise<NonconformanceReport> {
  const { data } = await apiClient.post<NonconformanceReport>(
    `/nonconformance-reports/${reportId}/approve`
  );
  return data;
}

export async function revokeNonconformanceReport(
  reportId: number
): Promise<NonconformanceReport> {
  const { data } = await apiClient.post<NonconformanceReport>(
    `/nonconformance-reports/${reportId}/revoke`
  );
  return data;
}

export async function deleteNonconformanceReport(reportId: number): Promise<void> {
  await apiClient.delete(`/nonconformance-reports/${reportId}`);
}


export async function downloadNonconformanceReportPdf(
  reportId: number,
  fileName?: string
): Promise<void> {
  await downloadPdfBlob(
    `/nonconformance-reports/${reportId}/pdf`,
    fileName || `부적합보고서_${reportId}.pdf`
  );
}
